import React from "react";
import SideBar from "../../components/Sidebar";
import { APP_INFO } from "../../constants/AppInfo";

const PrivacyPolicy = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}
          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Privacy Policy</h5>
                <div className="row">
                  <div className="container my-4">
                    <div className="row">
                      <div className="col-md-12">
                        <section id="privacy-policy">
                          <h6>Privacy Policy for {APP_INFO.companyName}</h6>
                          <p>
                            <strong>Last Updated:</strong> 01.01.2024
                          </p>

                          <h6>Introduction</h6>
                          <p>
                            {APP_INFO.companyName} (“us”, “we”, or “our”)
                            operates the website{" "}
                            <a href={APP_INFO.websiteUrl}>
                              {APP_INFO.domainName}
                            </a>{" "}
                            (collectively referred to as the “Service”).
                          </p>
                          <p>
                            This Privacy Policy describes how we collect, use,
                            store, and protect your personal information when
                            you interact with our Service. By using our Service,
                            you agree to the collection and use of information
                            in accordance with this policy.
                          </p>

                          <h6>Definitions</h6>
                          <ul>
                            <li>
                              <strong>Service</strong>: {APP_INFO.companyName}{" "}
                              website, mobile based application, and any
                              associated services.
                            </li>
                            <li>
                              <strong>Personal Data</strong>: Information that
                              can identify a living individual.
                            </li>
                            <li>
                              <strong>Usage Data</strong>: Automatically
                              collected data related to your usage of the
                              Service.
                            </li>
                            <li>
                              <strong>Cookies</strong>: Small data files stored
                              on your device.
                            </li>
                            <li>
                              <strong>Data Controller</strong>: Entity
                              determining the purpose and means of processing
                              personal data.
                            </li>
                            <li>
                              <strong>Data Processor (Service Provider)</strong>
                              : Entity that processes data on behalf of the Data
                              Controller.
                            </li>
                            <li>
                              <strong>User</strong>: Individual using our
                              Service.
                            </li>
                          </ul>

                          <h6>Scope</h6>
                          <p>This Privacy Policy applies when you:</p>
                          <ul>
                            <li>
                              Visit our website:{" "}
                              <a href={APP_INFO.websiteUrl}>
                                {APP_INFO.domainName}
                              </a>
                            </li>
                            <li>Use our mobile app: {APP_INFO.companyName}</li>
                            <li>
                              Interact with us via support, marketing, or events
                            </li>
                          </ul>

                          <h6>Types of Data Collected</h6>

                          <h6>Personal Data</h6>
                          <p>
                            We may collect personally identifiable information,
                            including but not limited to:
                          </p>
                          <ul>
                            <li>Full name, age, gender, date/place of birth</li>
                            <li>PAN, Aadhaar, passport, and KYC details</li>
                            <li>Username, user ID, password</li>
                            <li>
                              Contact details: email, phone, address, pincode
                            </li>
                            <li>Payment details: UPI ID, bank account</li>
                            <li>
                              Business/shop information, documents, and images
                            </li>
                            <li>Identification and address proofs</li>
                            <li>
                              Educational/employment details, agreements,
                              marital/family info
                            </li>
                          </ul>

                          <h6>Usage Data</h6>
                          <p>
                            Includes browser type, IP address, pages visited,
                            date/time, session duration, device type/ID, OS
                            version, and diagnostics.
                          </p>

                          <h6>Location Data</h6>
                          <p>
                            With permission, we may collect location data for
                            app functionality. You can disable this via device
                            settings.
                          </p>

                          <h6>Tracking & Cookies</h6>
                          <p>
                            We use cookies and similar technologies for session
                            management, preferences, analytics, and
                            advertisements.
                          </p>
                          <p>Examples:</p>
                          <ul>
                            <li>Session Cookies</li>
                            <li>Preference Cookies</li>
                            <li>Security Cookies</li>
                            <li>Advertising Cookies</li>
                          </ul>
                          <p>
                            You may refuse cookies, but some features may not
                            work properly.
                          </p>

                          <h6>How We Use Your Data</h6>
                          <p>We use your data to:</p>
                          <ul>
                            <li>Operate and maintain our Service</li>
                            <li>Notify you of changes or updates</li>
                            <li>Provide customer support</li>
                            <li>Analyze and improve performance</li>
                            <li>
                              Detect and prevent fraud and technical issues
                            </li>
                            <li>
                              Send marketing/promotional material (you may
                              opt-out)
                            </li>
                            <li>Enforce our Terms and Conditions</li>
                            <li>Comply with legal requirements</li>
                            <li>Fulfill any other purpose with your consent</li>
                          </ul>

                          <h6>Retention of Data</h6>
                          <ul>
                            <li>
                              <strong>Personal Data</strong> is retained as long
                              as necessary for the stated purposes.
                            </li>
                            <li>
                              <strong>Usage Data</strong> may be retained for
                              internal analytics or to comply with legal
                              obligations.
                            </li>
                          </ul>

                          <h6>Transfer of Data</h6>
                          <p>
                            Your data may be transferred and processed in India.
                            By using the Service and submitting your data, you
                            consent to such transfer. We ensure appropriate data
                            security measures are in place.
                          </p>

                          <h6>Disclosure of Data</h6>
                          <p>We may share your data:</p>
                          <ul>
                            <li>
                              In business transfers (e.g., mergers or
                              acquisitions)
                            </li>
                            <li>
                              With subsidiaries, affiliates, and trusted
                              third-party service providers
                            </li>
                            <li>
                              To comply with legal obligations or enforce our
                              rights
                            </li>
                            <li>
                              To protect the safety and security of users or the
                              public
                            </li>
                            <li>With your consent</li>
                          </ul>

                          <h6>Security of Data</h6>
                          <p>
                            We implement commercially acceptable security
                            practices to protect your data. However, no system
                            is 100% secure, and we cannot guarantee absolute
                            security.
                          </p>

                          <h6>Account Deletion</h6>
                          <p>
                            You may delete your account at any time by
                            contacting us at:{" "}
                            <strong>{APP_INFO.domainName}</strong>
                          </p>
                          <ul>
                            <li>
                              Account deletion is irreversible and takes up to
                              30 days.
                            </li>
                            <li>
                              All associated data, transaction history, and
                              login access will be removed.
                            </li>
                          </ul>

                          <h6>Service Providers</h6>
                          <p>We may use third-party vendors to:</p>
                          <ul>
                            <li>Host, operate, or enhance our Service</li>
                            <li>Provide customer support or analytics</li>
                            <li>
                              Manage marketing and automation (e.g., CI/CD
                              tools)
                            </li>
                            <li>
                              Facilitate behavioral remarketing or ad targeting
                            </li>
                          </ul>
                          <p>
                            These providers are obligated to protect your data
                            and use it only as instructed.
                          </p>

                          <h6>Analytics</h6>
                          <p>
                            We may use third-party analytics tools (e.g., Google
                            Analytics) to monitor traffic and user behavior on
                            our website and app.
                          </p>

                          <h6>CI/CD Tools</h6>
                          <p>
                            To ensure fast and secure updates, we may integrate
                            third-party CI/CD services for automated deployment
                            and testing.
                          </p>

                          <h6>Behavioral Remarketing</h6>
                          <p>
                            We may use remarketing services (e.g., Google Ads,
                            Facebook Ads) to serve ads on third-party platforms
                            based on your past interactions with our Service.
                          </p>
                          <p>
                            You can opt out of targeted ads via your browser or
                            ad settings.
                          </p>

                          <h6>Children’s Privacy</h6>
                          <p>
                            Our Service is not directed to anyone under the age
                            of 18. We do not knowingly collect personal data
                            from children. If you believe a child has provided
                            us personal data, contact us immediately.
                          </p>

                          <h6>Your Data Protection Rights</h6>
                          <p>
                            Depending on your jurisdiction, you may have the
                            right to:
                          </p>
                          <ul>
                            <li>Access or update your personal information</li>
                            <li>Object to processing or request restriction</li>
                            <li>Request deletion of your data</li>
                            <li>Withdraw consent</li>
                            <li>
                              Lodge complaints with a supervisory authority
                            </li>
                          </ul>

                          <h6>Changes to This Privacy Policy</h6>
                          <p>
                            We may update our Privacy Policy from time to time.
                            We will notify you of changes by posting the new
                            version on this page with a revised "Last Updated"
                            date.
                          </p>

                          <h6>Contact Us</h6>
                          <p>
                            If you have any questions about this Privacy Policy
                            or wish to exercise your rights, please contact us:
                          </p>
                          <ul>
                            <li>
                              <strong>Email:</strong> {APP_INFO.email}
                            </li>
                          </ul>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
